<template>
  <a-card :bordered="false">
    <div>
      <a-form :form="form" >
        <a-form-item label="系统编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
        </a-form-item>
        <a-form-item label="前提条件" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['prerequisites', {rules: [{required: true, message: '必填项，请填写信息'}]}]" :rows="5"/>
        </a-form-item>
        <a-form-item label="约束条件" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['constraints', {rules: [{required: true, message: '必填项，请填写信息'}]}]" :rows="5"/>
        </a-form-item>
        <a-form-item
          v-bind="buttonCol"
        >
          <a-row>
            <a-col span="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
            <a-col span="8"></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import { pre_risk_control_update, pre_risk_control_list } from '@/api/trade_risk_control'

export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0
    }
  },
  mounted () {
    this.id = this.$route.params.control_id
    this.$nextTick(() => {
      pre_risk_control_list({ id: this.id })
        .then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.loadEditInfo(list[0])
          }
        })
    })
  },
  methods: {
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          console.log('Received values of form: ', values)
        }
        pre_risk_control_update(values, this.id)
          .then((res) => {
            this.handleGoBack()
            console.log(res, '修改成功')
    })
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, ['number', 'prerequisites', 'constraints'])
        console.log('formData', formData)
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
